import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

const MAX_RETRIES = 60
const RETRY_DELAY_MS = 1000

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
const Portal = ({ children, path = 'root', isInBody = false }) => {
  const [portalRoot, setPortalRoot] = useState(() => {
    if (isInBody) {
      return document.body
    }
    return document.getElementById(path)
  })
  const [retryCount, setRetryCount] = useState(0)

  useEffect(() => {
    // If we already have a valid portal root, no need to retry
    if (portalRoot || isInBody) {
      return
    }

    // If we've exhausted retries, stop trying
    if (retryCount >= MAX_RETRIES) {
      return
    }

    // Retry finding the element
    const timer = setTimeout(() => {
      const element = document.getElementById(path)
      if (element) {
        setPortalRoot(element)
      } else {
        setRetryCount((prev) => prev + 1)
      }
    }, RETRY_DELAY_MS)

    return () => clearTimeout(timer)
  }, [path, portalRoot, retryCount, isInBody])

  // If we don't have a valid portal root, don't render anything
  // This prevents the "target container is not a DOM element" error
  if (!portalRoot) {
    return null
  }

  return ReactDOM.createPortal(children, portalRoot)
}

export default Portal
